/**
 * Created by alexchetv on 16.11.2017.
 */
import PouchDB from 'pouchdb';

class DataDB {
  constructor(name, options, remoteName, remoteOptions) {
    console.log('DATA ', name, remoteName);
    this._local = new PouchDB(name, options);
    this._remote = new PouchDB(remoteName, remoteOptions);
    this._local.setMaxListeners(20);
    this._remote.setMaxListeners(20);
  }

  sync(options) {
    return PouchDB.sync(this._local, this._remote, options);
  }

  close() {
    return Promise.all([
      () => {
        if (this._local && this._local.close) {
          return this._local.close();
        }
        return false;
      },
      () => {
        if (this._remote && this._remote.close) {
          return this._remote.close();
        }
        return false;
      },
    ]);
  }

  destroy() {
    console.log('DATA destroy');
    return this._local.destroy();
  }

  info() {
    return this._local.info();
  }

  allDocs(options, remote = false) {
    if (remote) {
      return this._remote.allDocs(options);
    }
    return this._local.allDocs(options);
  }

  trackChanges(cb) {
    this._local.changes({
      since: 'now',
      live: true,
      include_docs: true,
    })
      .on('change', (info) => {
        console.log('DATA change', info);
        if (info.doc) {
          cb(info.doc);
        } else {
          console.log('**************** EMPTY CHANGE *********************');
        }
      });
  }

  put(...arg) {
    // console.log('DATA put', ...arg);
    return this._local.put(...arg);
  }

  get(...arg) {
    return this._local.get(...arg);
  }

  remove(doc) {
    return this._local.remove(doc);
  }

  /**
   * //to change credentials on-fly we must replace <var ajaxOpts>
   *   on <api.ajaxOpts> in  PouchDB index(-browser).js
   *   and others in node_modules/pouchdb/lib
   *
   */
  setToken(token) {
    this._remote.ajaxOpts.headers.Authorization = `Basic ${token}`;
  }

  query(name, options) {
    return this._local.query(name, options);
  }

  getAttachment(mediaId) {
    return this._local.getAttachment(mediaId, 'media')
      .catch((err) => {
        console.log('getAttachment in local error.status', err.status);
        if (err.status === 404) { // if not found in local let's seek in remote
          return this._remote.getAttachment(mediaId, 'media');
        }
        throw err;
      });
  }

  /* getAttachment(mediaId) {
    const it = this;
    return this._local.getAttachment(mediaId, 'media')
      .catch((err) => {
        console.log('getAttachment in local error.status', err.status);
        if (err.status === 404) { // if not found in local let's seek in remote
          return it._remote.getAttachment(mediaId, 'media');
        }
        throw err;
      })
      .catch((err) => {
        console.log('getAttachment error 2', err);
        if (err.status === 401) {
          return store.dispatch('refreshUser') // getAttachment
            .then((user) => {
              console.log('DATA refreshUser user', user);
              return it._remote.getAttachment(mediaId, 'media');
            })
            .catch((err2) => {
              console.log('getAttachment error 3', err2);
              throw err2;
            });
        }
        throw err;
      });
  } */

  getThumb(mediaId) {
    return this._remote.getAttachment(mediaId, 'thumb');
  }
}
export default DataDB;



// WEBPACK FOOTER //
// ./src/others/data.js